<template>
  <div class="orders-page">
    <div class="orders-hero">
      <div>
        <p class="hero-kicker mb-1">حساب کاربری</p>
        <h1 class="mb-0">سفارش‌های من</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count" v-if="paginationMeta && paginationMeta.total != null">
          <strong>{{ formatNumber(paginationMeta.total) }}</strong>
          <span>سفارش</span>
        </div>
        <div class="hero-badge">
          <i class="bi bi-bag-heart"></i>
        </div>
      </div>
    </div>

    <div class="orders-list-panel">
      <table-items :items="items" :restoreState="false"/>
      <div class="orders-pager">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination";
import tableItems from "../../components/dashboard/orders/tableItems.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import "../../components/dashboard/orders/orders-ui.css";

export default {
  name: "orders",
  components: {Pagination, tableItems},
  mounted() {
    this.$store.dispatch("ShoppingCart/getOrders");
  },
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getOrders",
      paginationMeta: "ShoppingCart/getPaginationMeta",
    }),
  },
  methods: {
    formatNumber,
    changePage(page) {
      this.$store.dispatch("ShoppingCart/getOrders", page);
    },
  },
};
</script>
<style scoped>
.orders-page {
  padding: 8px 4px 24px;
}

.orders-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: linear-gradient(135deg, #1e1e1e 0%, #3a3a3a 55%, #eb3d60 140%);
  color: #fff;
  border-radius: 22px;
  padding: 24px 28px;
  margin-bottom: 22px;
}

.hero-kicker {
  opacity: 0.8;
  font-size: 13px;
}

.orders-hero h1 {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 0;
}

.hero-side {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.hero-count {
  text-align: left;
}

.hero-count strong {
  display: block;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.1;
}

.hero-count span {
  font-size: 12px;
  opacity: 0.8;
}

.hero-badge {
  width: 64px;
  height: 64px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.orders-pager {
  padding: 12px 8px 4px;
}

@media (max-width: 767px) {
  .orders-hero {
    padding: 16px 18px;
    align-items: center;
  }

  .hero-badge {
    display: none;
  }

  .orders-hero h1 {
    font-size: 22px;
  }

  .hero-badge {
    width: 48px;
    height: 48px;
    font-size: 22px;
    border-radius: 14px;
  }

  .hero-count strong {
    font-size: 20px;
  }
}
</style>
